import PaginationComponent from "./Pagination.container";
export default PaginationComponent;
